import { render, staticRenderFns } from "./MarksLegalsPgHeader.vue?vue&type=template&id=aacdc83e&scoped=true&"
import script from "./MarksLegalsPgHeader.vue?vue&type=script&lang=js&"
export * from "./MarksLegalsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarksLegalsPgHeader.vue?vue&type=style&index=0&id=aacdc83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacdc83e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
